import React, { useLayoutEffect, useState } from 'react'
import classNames from 'classnames'
import { HEADER_CONTAINER_DOM_ID } from 'web/containers/HeaderContainer'
import { useScrollDistance } from 'web/hooks/useScrollDistance'

type SidebarProps = {
    /**
     * If true, sidebar will act like it's sticky, currently only
     * tested for the edit-fight-setup view.
     */
    sticky?: boolean
    children?: React.ReactNode
}

export const Sidebar = (props: SidebarProps): JSX.Element | null => {

    // TODO: All this can be optimized away if we're not sticky

    const [sidebarOffset, setSidebarOffset] = useState(`100vh`)
    const scrollDistance = useScrollDistance()

    useLayoutEffect(() => {
        const headerHeight = document.getElementById(HEADER_CONTAINER_DOM_ID)?.clientHeight ?? 0
        setSidebarOffset(`calc(100vh - ${Math.max(headerHeight - scrollDistance, 0)}px)`)
    }, [scrollDistance])

    if (props.sticky) {
        return (
            <div
                className={classNames(
                    "small-hover-scrollbar",
                    "p-3 bg-light d-flex flex-column border-right",
                )}
                style={{
                    position: "sticky",
                    top: 0,
                    minWidth: "315px",
                    height: sidebarOffset,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    overscrollBehavior: 'contain',
                }}
            >
                {props.children}
            </div>
        )
    }

    return (
        <div
            style={{
                minWidth: "315px",
            }}
            className={classNames("p-3 border-right flex-shrink-0 bg-light")}
        >
            {props.children}
        </div>
    )
}
